"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.anchorLink = exports.formSubmitButtonLink = exports.loginToWixLink = exports.addressLink = exports.whatsAppLink = exports.phoneLink = exports.dynamicPageLink = exports.pageLink = exports.externalLink = exports.emailLink = exports.documentLink = void 0;
var yup = __importStar(require("yup"));
var schemaUtils_1 = require("../schemaUtils");
var documentLink = schemaUtils_1.createDataSchema('DocumentLink', yup.object({
    docId: yup.string(),
    name: yup.string(),
    indexable: yup.boolean(),
}));
exports.documentLink = documentLink;
var anchorLink = schemaUtils_1.createDataSchema('AnchorLink', yup.object({
    anchorName: yup.string(),
    anchorDataId: schemaUtils_1.createWeakDataRef('Anchor'),
    pageId: schemaUtils_1.createWeakDataRef('Page'),
}));
exports.anchorLink = anchorLink;
var emailLink = schemaUtils_1.createDataSchema('EmailLink', yup.object({
    recipient: yup.string(),
    subject: yup.string(),
    body: yup.string(),
}));
exports.emailLink = emailLink;
var externalLink = schemaUtils_1.createDataSchema('ExternalLink', yup.object({
    url: yup.string(),
    target: yup
        .mixed()
        .oneOf(['_self', '_blank'])
        .default('_blank'),
}));
exports.externalLink = externalLink;
var pageLink = schemaUtils_1.createDataSchema('PageLink', yup.object({
    pageId: schemaUtils_1.createWeakDataRef('Page'),
    target: yup
        .mixed()
        .oneOf(['_self', '_blank'])
        .default('_self'),
}));
exports.pageLink = pageLink;
var dynamicPageLink = schemaUtils_1.createDataSchema('DynamicPageLink', yup.object({
    routerId: yup.string(),
    innerRoute: yup.string(),
    anchorDataId: yup.string(),
    isTpaRoute: yup.boolean(),
}));
exports.dynamicPageLink = dynamicPageLink;
var phoneLink = schemaUtils_1.createDataSchema('PhoneLink', yup.object({
    phoneNumber: yup.string().max(100),
}));
exports.phoneLink = phoneLink;
var whatsAppLink = schemaUtils_1.createDataSchema('WhatsAppLink', yup.object({
    phoneNumber: yup.string(),
}));
exports.whatsAppLink = whatsAppLink;
var addressLink = schemaUtils_1.createDataSchema('AddressLink', yup.object({
    address: yup.string(),
}));
exports.addressLink = addressLink;
var loginToWixLink = schemaUtils_1.createDataSchema('LoginToWixLink', yup.object({
    postLoginUrl: yup.string(),
    postSignupUrl: yup.string(),
    dialog: yup
        .mixed()
        .oneOf(['createUser', 'login', 'showLogin'])
        .default('login'),
    sendMail: yup.boolean().default(true),
    mailTemplate: yup.string(),
    userColor: yup.string(),
    loginCompName: yup.string().default(''),
}));
exports.loginToWixLink = loginToWixLink;
var formSubmitButtonLink = schemaUtils_1.createDataSchema('FormSubmitButtonLink', yup.object({}));
exports.formSubmitButtonLink = formSubmitButtonLink;
//# sourceMappingURL=Link.schema.js.map